module.exports = __webpack_public_path__ + "static/img/xiugaiyinliang2.6235a44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/xiugaiyinliang2.png
// module id = aeKS
// module chunks = 24